<div class="request-body">
  <div class="row content-type">
    <app-select [formGroup]="formGroup()!" [model]="$safeNavigationMigration(model()?.contentType)" [meta]="metaContentType"></app-select>
  </div>
  <div class="row">
    <app-toggle [formGroup]="formGroup()!" [model]="$safeNavigationMigration(model()?.editable)" [meta]="metaEditable"></app-toggle>
  </div>
  <div class="row">
    <app-textarea [formGroup]="formGroup()!" [model]="$safeNavigationMigration(model()?.content)" [meta]="metaContent"></app-textarea>
  </div>
</div>
